<template>
 <div class="bg">
   <div class="wrapper">
     <div class="text">您的手机号已被</div>
     <div class="text mb25">身份证{{idcard.slice(0,8)+"****"+idcard.slice(-2)}}绑定</div>
     <input type="button" class="btn" @click="original" value="使用原身份证" />
     <input type="button" class="btn" @click="clickBtn" value="绑定新身份证" />
     <div class="close" @click="back"></div>
   </div>
 </div>
</template>

<script>
  import {CommonUtil} from "../common/CommonUtil";
 export default {
   name: 'phoneId',
   props:['idcard'],
   methods: {
     back: function () {
       this.$emit("close");
     },
     clickBtn:function() {
       //绑定新
       this.$emit("popClick");
     },
     original:function () {
       //使用原来的
       var _this=this;
       CommonUtil.setInfo("绑定失败");
       window.setTimeout(function () {
         _this.$emit("original");
       },2000);
     }
   }
 }
</script>

<style scoped lang="sass">
  .bg
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100%
    background: rgba(0,0,0,0.5)

  .wrapper
    position: relative
    box-sizing: border-box
    margin: -150px auto 0
    top: 50%
    padding-top: 42px
    width: 478px
    height: 301px
    text-align: center
    background: #fff

  .text
    font-size: 20px
    line-height: 34px
    text-align: center

  .btn
    margin-bottom: 24px
    width: 296px
    height: 45px
    background: $themecolor1
    font-size: 16px
    color: #fff
    border: none
    border-radius: 4px

  .btn:hover
    background: $themecolor1

  .mb25
    margin-bottom: 25px
  .close
    background: url("../assets/images/Close.png") no-repeat
    background-size: contain
</style>
